export default __webpack_public_path__ + "static/3-961217567fd25268b536a360a1c16b31.png";